






import { Component, Vue } from "vue-property-decorator";
import LaundrySupervisiList from "@/components/laundry/supervisi/LaundrySupervisiList.vue";

@Component({
  components: { LaundrySupervisiList }
})
export default class LaundrySupervisiPage extends Vue {}
